import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'pagetitle',
  templateUrl: './pagetitle.component.html',
  styles: []
})

export class PageTitle implements OnInit {
  @Input() title: string;

  constructor() { }

  ngOnInit() {
  }

}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/pagetitle/pagetitle.component.ts